<template>
  <b-card
    no-body
    class="card-payment"
  >
    <b-card-header>
      <b-card-title>
        <div>Pembeli dan Alamat</div>
        <small>Merchant: {{ data.merchant.name }} ({{ data.invoice_number }})</small>
      </b-card-title>
      <b-card-title>
        <div class="text-right">
          <b-badge
            v-if="statusOrder"
            :variant="statusOrder.color"
          >
            {{ statusOrder.title }}
          </b-badge>
        </div>
      </b-card-title>
    </b-card-header>

    <b-card-body>
      <b-alert
        v-if="registryOwner"
        class="mt-0 mb-2"
        variant="dark"
        style="background-color: #FFECF6 !important;"
        show
      >
        <div class="form-row align-items-center">
          <div
            v-if="registryOwner.photo_url"
            class="col-auto position-relative pr-75"
          >
            <b-avatar
              :src="linkStaging(registryOwner.photo_url, 50, 50)"
              :text="registryOwner.name.charAt(0)"
              variant="light-primary"
              style="width: 32px; height: 32px;"
            />

            <div
              style="width: 20px; min-width: 20px; height: 20px; min-height: 20px; right: 6px; bottom: -4px; background-color: #F90A7F"
              class="position-absolute d-flex align-items-center justify-content-center rounded-circle"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="13px"
                viewBox="0 -960 960 960"
                width="13px"
                fill="#FFFFFF"
                style="transform: translateY(1px)"
              ><path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z" /></svg>
            </div>
          </div>
          <div
            v-else
            class="col-auto pr-25"
          >
            <div
              style="width: 20px; min-width: 20px; height: 20px; min-height: 20px; background-color: #F90A7F"
              class="d-flex align-items-center justify-content-center rounded-circle"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="13px"
                viewBox="0 -960 960 960"
                width="13px"
                fill="#FFFFFF"
                style="transform: translateY(1px)"
              ><path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z" /></svg>
            </div>
          </div>

          <div class="col">
            Ini adalah kado registry untuk mom
            <b-link
              :href="registryLink.link"
              target="_blank"
              class="alert-link"
            >
              <strong>{{ registryOwner.name }}</strong>
              <feather-icon
                icon="ExternalLinkIcon"
                size="14"
                class="ml-25"
              />
            </b-link>
          </div>

          <div
            v-if="userData.role === 'admin'"
            class="col-auto"
          >
            <a
              style="color: #F90A7F !important;"
              class="alert-link"
              @click="showWishesModal = true"
            >Lihat Ucapan</a>
          </div>
        </div>

      </b-alert>

      <b-alert
        v-if="data.gift_product && !registryOwner"
        variant="secondary"
        show
      >
        Registry dinonaktifkan. Akun pemilik tidak tersedia atau sudah dihapus.
      </b-alert>

      <b-row>
        <b-col>
          <dl>
            <dt>
              Pembeli
            </dt>
            <dd>
              {{ buyerName }} <span v-if="data.buyer && data.buyer.phone && canAccess('read', 'UserPhone')">(<a
                :href="`https://wa.me/${data.buyer.phone}`"
                target="_blank"
                class="link"
              >+{{ data.buyer.phone }}</a>)</span>
            </dd>
          </dl>
          <dl v-if="data.delivery">
            <dt>
              Alamat Pengiriman
            </dt>
            <dd>
              {{ data.delivery.consignee_name }} <span v-if="canAccess('read', 'UserPhone')">(<a
                :href="`https://wa.me/${data.delivery.consignee_phone}`"
                target="_blank"
                class="link"
              >+{{ data.delivery.consignee_phone }}</a>)</span><br>
              <small>{{ data.delivery.fullAddress }}</small>
            </dd>
          </dl>
          <dl v-if="registryOwner">
            <dt>
              Registry
            </dt>
            <dd>
              {{ registryOwner.name }} <span v-if="registryOwner.phone && canAccess('read', 'UserPhone')">(<a
                :href="`https://wa.me/${registryOwner.phone}`"
                target="_blank"
                class="link"
              >+{{ registryOwner.phone }}</a>)</span>
            </dd>
          </dl>
        </b-col>
        <b-col>
          <dl>
            <dt class="text-right">
              Tanggal Pembayaran
            </dt>
            <dd
              v-if="data.accepted_at"
              class="text-right"
            >
              {{ formatDate(data.accepted_at) }} ({{ formatTime(data.accepted_at) }})
            </dd>
            <dd
              v-else
              class="text-right"
            >
              <i>Belum dibayar</i>
            </dd>
          </dl>
        </b-col>
      </b-row>
    </b-card-body>

    <b-modal
      v-if="data.gift_product && data.contributor"
      v-model="showWishesModal"
      title="Ucapan Pembeli"
    >
      <div class="form-row mb-50">
        <div class="col-3">
          Oleh
        </div>
        <div class="col-auto">
          :
        </div>
        <div
          v-if="editWish"
          class="col"
        >
          <b-form-input
            v-model="contributorName"
            size="sm"
          />
        </div>
        <div
          v-else-if="data.contributor.contributor_name"
          class="col font-weight-bold"
        >
          {{ data.contributor.contributor_name }}
        </div>
        <div
          v-else
          class="col font-weight-bold"
        >
          {{ buyerName }}
        </div>
      </div>
      <div class="form-row">
        <div class="col-3">
          Ucapan
        </div>
        <div class="col-auto">
          :
        </div>
        <div
          v-if="editWish"
          class="col"
        >
          <b-form-textarea
            v-model="wishText"
            rows="2"
          />
        </div>
        <div
          v-else-if="data.contributor.message"
          class="col"
          style="white-space: pre-line;"
        >
          {{ data.contributor.message }}
        </div>
        <div
          v-else
          class="col"
        >
          <i>Pembeli tidak menulis ucapan</i>
        </div>
      </div>
      <template #modal-footer>
        <div
          v-if="editWish"
          class="w-100 d-flex justify-content-between"
        >
          <b-button
            variant="outline-secondary"
            @click="requestEditWish"
          >
            Batal
          </b-button>
          <b-button
            variant="primary"
            :disabled="isLoading"
            @click="updateWish"
          >
            <b-spinner
              v-if="isLoading"
              small
              class="mr-50"
            />
            Simpan
          </b-button>
        </div>
        <div
          v-else
          class="w-100 d-flex justify-content-between"
        >
          <b-button
            variant="outline-primary"
            @click="requestEditWish"
          >
            Ubah Ucapan
          </b-button>
          <b-button
            variant="secondary"
            @click="showWishesModal = false"
          >
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BCard,
  BCardHeader,
  BFormTextarea,
  BFormInput,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BAlert,
  BBadge,
  BLink, BAvatar, BModal, BButton, BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BButton,
    BAvatar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BFormTextarea,
    BFormInput,
    BSpinner,
    BRow,
    BCol,
    BAlert,
    BBadge,
    BLink,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      wishText: '',
      contributorName: '',
      showWishesModal: false,
      editWish: false,
      isLoading: false,
    }
  },
  computed: {
    buyerName() {
      return this.data.buyer ? this.data.buyer.name : 'Akun tidak tersedia'
    },
    ...mapState('transaction', ['tabStatusList']),
    userData() {
      return this.$store.state.auth.userData ? this.$store.state.auth.userData : JSON.parse(localStorage.getItem('userData'))
    },
    statusOrder() {
      if (this.data) {
        const statusOrder = this.tabStatusList.filter(el => el.category === 'order')
        const thisStatus = statusOrder.find(el => el.value === this.data.status)

        if (!thisStatus && this.data.status === 'confirmed') {
          return {
            title: 'Belum Dibayar',
            value: 'confirmed',
            category: 'order',
            color: 'secondary',
            count: 0,
          }
        }

        return thisStatus
      }

      return ''
    },
    registryOwner() {
      return this.data.gift_product && this.data.gift_product.owner_gift
        ? this.data.gift_product.owner_gift.owner : null
    },
    registryLink() {
      if (this.registryOwner && this.registryOwner.username) {
        return {
          link: `${process.env.VUE_APP_CLIENT_URL}/${encodeURIComponent(this.registryOwner.username)}`,
          username: this.registryOwner.username,
        }
      }

      return ''
    },
  },
  methods: {
    ...mapActions('transaction', ['updateGiftProductContributor']),
    requestEditWish() {
      if (this.editWish) {
        this.wishText = ''
        this.contributorName = ''
        this.editWish = false
      } else {
        this.wishText = this.data.contributor.message || ''
        this.contributorName = this.data.contributor.contributor_name || this.buyerName
        this.editWish = true
      }
    },
    async updateWish() {
      try {
        this.isLoading = true
        await this.updateGiftProductContributor({
          id: this.data.contributor.id,
          data: {
            contributor_name: this.contributorName,
            message: this.wishText,
          },
        })

        // Update local data directly
        this.data.contributor.contributor_name = this.contributorName
        this.data.contributor.message = this.wishText

        this.editWish = false
        this.showWishesModal = false
      } catch (error) {
        // error handled in action
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
dt {
    font-weight: bolder !important;
}
</style>
